import axios from 'axios';
import baseURL from '../../utils/base-url';

const jhsfBookingsApi = axios.create({
  baseURL,
});

export default jhsfBookingsApi;
